import React from 'react';
import PropTypes from 'prop-types';
import { SplitButton } from 'react-bootstrap/lib';
import DeleteButton from './DeleteButton';

function EditButton({ group, onEdit, onDelete }) {
  const { id } = group;

  return (
    <SplitButton
      title="Edit"
      key={id}
      id={`split-button-basic-group-${id}`}
      onClick={() => {
        onEdit(id);
      }}
    >
      <DeleteButton group={group} onDelete={onDelete} />
    </SplitButton>
  );
}

EditButton.propTypes = {
  id: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  group: PropTypes.object,
};

export default EditButton;
